module.exports = __webpack_public_path__ + "geoCompassMinus.714e73469dfd2b6b99156cde26d40c49.png";